import React from "react";
import { formatAmountParts, formatMoney } from "./treasuryHelpers";

function LiabilityRow({ label, meta, amount, share }) {
  return (
    <div className="atrs-data-row">
      <div className="atrs-data-name">
        <span>{label}</span>
        {meta ? <small>{meta}</small> : null}
      </div>
      <span className="atrs-data-share tabular-nums">{share}</span>
      <strong className="atrs-data-amount tabular-nums">{amount}</strong>
    </div>
  );
}

export default function TreasuryBreakdownPanel({ segments, total, escrowRows }) {
  const totalCashEq = escrowRows.reduce((sum, row) => sum + (row.cashEq || 0), 0);

  return (
    <section className="atrs-workspace-section" aria-label="Liabilities">
      <header className="atrs-workspace-heading">
        <div>
          <p className="atrs-section-kicker">Balances</p>
          <h2>What the treasury owes</h2>
        </div>
        <strong className="atrs-workspace-total tabular-nums">
          {formatMoney(total, { currency: "CASH", compact: true })}
        </strong>
      </header>

      <div className="atrs-ledger-grid">
        <div className="atrs-ledger-group">
          <div className="atrs-ledger-group-head">
            <h3>Wallet balances</h3>
            <span>Share</span>
            <span>Amount</span>
          </div>
          {segments.length ? (
            segments.map((row) => (
              <LiabilityRow
                key={row.id}
                label={row.label}
                share={`${row.pct.toFixed(1)}%`}
                amount={formatMoney(row.value, { currency: "CASH", compact: true })}
              />
            ))
          ) : (
            <p className="atrs-empty-inline">No liabilities recorded.</p>
          )}
        </div>

        <div className="atrs-ledger-group">
          <div className="atrs-ledger-group-head">
            <h3>Escrow exposure</h3>
            <span>{formatMoney(totalCashEq, { currency: "CASH", compact: true })} eq.</span>
            <span>Amount</span>
          </div>
          {escrowRows.length ? (
            escrowRows.map((row) => (
              <LiabilityRow
                key={row.key}
                label={row.label}
                meta={`${row.count || 0} open`}
                share={row.currency}
                amount={formatAmountParts(row.total).value}
              />
            ))
          ) : (
            <p className="atrs-empty-inline">No locked escrow right now.</p>
          )}
        </div>
      </div>
    </section>
  );
}
